import {
  ImageScaleView,
  LinearAddFilter,
  View,
} from '@play-co/timestep-core/ui';

interface SparkleFxOptions {
  superview: View;
  width: number;
  height: number;
  x?: number;
  y?: number;
  amount?: number;
  scale?: number;
  shineDuration?: number;
}

export default class SparkleFx extends View {
  private shines: ImageScaleView[] = [];
  private time: number;
  private duration: number;
  private scale: number;

  constructor(opts: SparkleFxOptions) {
    super({
      ...opts,
      centerOnOrigin: true,
      centerAnchor: true,
      scale: 1,
    });

    this.duration = opts.shineDuration ?? 3;
    this.time = Math.random() * this.duration * 100;
    this.scale = opts.scale ?? 1;

    const amount = opts.amount ?? 3;

    for (let index = 0; index < amount; index++) {
      const sparkle = new ImageScaleView({
        superview: this,
        image: 'assets/ui/match2/team/fx_sparkle.png',
        width: 12,
        height: 12,
        centerOnOrigin: true,
        centerAnchor: true,
        filter: new LinearAddFilter('rgba(255, 255, 255, 0.5)'),
      });

      this.shines.push(sparkle);
    }
  }

  public tick(dt: number) {
    this.time += dt * 0.001;
    const delay = this.duration / this.shines.length;

    this.shines.forEach((shine, index) => {
      const t = this.time + delay * index;
      const a = (t % this.duration) / this.duration;
      const b = Math.floor(t / this.duration) + index;
      const ratio = Math.max(0, Math.pow(Math.sin(a * Math.PI * 2), 3));
      shine.style.opacity = ratio;
      shine.style.scale = ratio * this.scale;
      shine.style.x = (b * 0.785 * this.style.width) % this.style.width;
      shine.style.y = (b * 0.912 * this.style.height) % this.style.height;
    });
  }
}
